module.exports = __webpack_public_path__ + "img/man_back.8528b9ec.png";